// extracted by mini-css-extract-plugin
export default {"l":"_180e947ca7"};